import { Navigate, Outlet, useParams } from "react-router-dom";

import { useGetChannel } from "@/features/channel/api";

/** Each page under a channel draws its own header and loading state. */
export const ManageChannels = () => {
  const { id } = useParams<{ id: string }>();
  const { data: channel, isLoading } = useGetChannel(id!);

  if (!isLoading && !channel) {
    return <Navigate replace to="/channels" />;
  }

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <Outlet />
    </div>
  );
};
